import React from 'react';

const PartnersSection = () => {
  return (
    <div className='md:px-24 px-4 md:mt-8 mt-4'>
        <div className="flex md:gap-4 gap-1 items-center md:mb-6 mb-2">
        <h2 className="text-[#03897B] text-[10px] md:text-[32px] font-bold">
        PARTNERS
        </h2>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746386728/Expand_right_14_xsloli.png"
          alt="l"
          className="md:w-[57px] md:h-[59px] h-[13px] w-[13px]"
        />
      </div>
      <div className="w-full md:h-[210px] bg-[#E7EBEB] flex flex-col items-start justify-center md:py-0 py-4 md:px-8 px-5 rounded-t-md">
        {/* Logos Section */}
        <div className="flex flex-wrap items-center justify-between w-full md:gap-6 gap-3 mb-4">
          <a href="https://www.cogta.gov.za/" target="_blank" rel="noopener noreferrer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745841586/image_1646_gh6bff.png"
              alt="Logo 1"
              className="h-5 md:h-20 w-auto"
            />
          </a>
          <a href="https://www.agriseta.co.za/" target="_blank" rel="noopener noreferrer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745841587/image_1647_dbsxnd.png"
              alt="Logo 2"
              className="h-5 md:h-20 w-auto"
            />
          </a>
          <a href="https://foodbev.co.za/" target="_blank" rel="noopener noreferrer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745841587/image_1648_yee7jx.png"
              alt="Logo 3"
              className="h-5 md:h-20 w-auto"
            />
          </a>
          <a href="https://www.servicesseta.org.za/" target="_blank" rel="noopener noreferrer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745841587/image_1715_note37.png"
              alt="Logo 4"
              className="h-5 md:h-20 w-auto"
            />
          </a>
          <a href="https://www.nandos.co.za/" target="_blank" rel="noopener noreferrer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745841587/image_cfqgt6.png"
              alt="Logo 5"
              className="h-5 md:h-24 w-[30px] md:w-[100px]"
            />
          </a>
        </div>

        {/* Text Section */}
        <p className="text-left md:mt-1 text-[6px] md:text-[20px] font-light text-black">
          Click logo to view more in the partners' websites
        </p>
      </div>
    </div>
  );
};

export default PartnersSection;
